import React, { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext();

export const useAuth = () => {
    return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
    const [authToken, setAuthToken] = useState(localStorage.getItem('authToken'));
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    // Login function
    const login = (token) => {
        setAuthToken(token);
        localStorage.setItem('authToken', token);
    };

    // Logout function
    const logout = () => {
        setAuthToken(null);
        localStorage.removeItem('authToken');
        navigate('/login');
    };

    // Sync authToken state with localStorage
    useEffect(() => {
        const token = localStorage.getItem('authToken');
        setAuthToken(token);
        setLoading(false);
    }, []);

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <AuthContext.Provider value={{ authToken, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
